<template>
  <div>
    <v-btn color="primary" style="padding: 0px 8px 0px 8px;margin: 6px 4px;" @click="onExport" outline>
      {{ $t('demo_file') }}
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import XLSX from 'xlsx' // import xlsx
export default {
  data() {
    return {
      Category: [{ CategoryName: '' }],
      Product: [
        {
          CategoryName: '',
          SKU: '',
          ProductName: '',
          ImageURL: '',
          ProductDesc: '',
          Price: '',
          DiscountPrice: '',
          Weight: ''
        }
      ],
      Option: [
        {
          ProductName: '',
          SKU: '',
          Option1Name: '',
          Option1: '',
          Option2Name: '',
          Option2: '',
          Quantity: '',
          Price: '',
          DiscountPrice: '',
          Weight: ''
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    onExport() {
      const optionWS = XLSX.utils.json_to_sheet(this.Option)
      const categoryWS = XLSX.utils.json_to_sheet(this.Category)
      const productWS = XLSX.utils.json_to_sheet(this.Product)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb,categoryWS,'Category')
      XLSX.utils.book_append_sheet(wb,optionWS, 'Option')
      XLSX.utils.book_append_sheet(wb,productWS, 'Product')

      XLSX.writeFile(wb, 'demoexcel.xlsx')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/demoFile.vue